import { vuexfireMutations, firestoreAction } from "vuexfire"

const getDefaultState = () => {
	return {
		current: {},
		index: [],
		broker_targets: [],
	}
}

export const state = () => ({
	current: {},
	index: [],
	broker_targets: [],
})

export const mutations = {
	...vuexfireMutations,
	SET_INDEX(state, docs) {
		state.index = docs
	},
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
}

export const actions = {
	bind: firestoreAction(async function ({ bindFirestoreRef }, id) {
		const ref = this.$fire.firestore.collection("users").doc(id)
		await bindFirestoreRef("current", ref, { wait: true })
	}),
	unbind: firestoreAction(function ({ unbindFirestoreRef }) {
		unbindFirestoreRef("current", () => {
			return {}
		})
	}),
	async bindIndex({ commit }) {
		const ref = this.$fire.firestore.collection("users").orderBy("first_name", "asc")
		ref.onSnapshot((snapshot) => {
			const docs = snapshot.docs.map((doc) => ({
				id: doc.id,
				first_name: doc.data().first_name || "",
				last_name: doc.data().last_name || "",
				status: doc.data().status || "enabled",
			}))
			commit("SET_INDEX", docs) // Always use commit to change state
		})
	},
	unbindIndex: firestoreAction(function ({ unbindFirestoreRef }) {
		unbindFirestoreRef("index", () => {
			return []
		})
	}),
	bindBrokerTargets: firestoreAction(async function ({ bindFirestoreRef }, userId) {
		const ref = this.$fire.firestore.collection(`users/${userId}/broker_targets`).orderBy("year", "desc").orderBy("month", "desc")
		await bindFirestoreRef("broker_targets", ref, { wait: true })
	}),
	unbindBrokerTargets: firestoreAction(function ({ unbindFirestoreRef }) {
		unbindFirestoreRef("broker_targets", () => {
			return []
		})
	}),
	reset({ commit, dispatch }) {
		dispatch("unbind")
		dispatch("unbindBrokerTargets")
		commit("RESET_STATE")
	},
}

export const getters = {
	getCurrent(state) {
		return state.current
	},
	getIndex(state) {
		return state.index
	},
	getLabelledIndex(state) {
		const transformed = state.index.map(({ first_name, last_name, id }) => ({
			label: `${first_name} ${last_name}`,
			value: id,
		}))
		return transformed
	},
	getFilteredLabelledIndex(state, getters, rootState, rootGetters) {
		// Get the filter_brokers setting from globals
		const settings = rootGetters["globals/getSettings"]
		const filterBrokers = settings?.filter_brokers || []

		// If no filter is set, return all users
		if (!filterBrokers || filterBrokers.length === 0) {
			return getters.getLabelledIndex
		}

		// Filter the index to only include selected brokers
		const filtered = state.index
			.filter(({ id }) => filterBrokers.includes(id))
			.map(({ first_name, last_name, id }) => ({
				label: `${first_name} ${last_name}`,
				value: id,
			}))

		return filtered
	},
	getAccountExecutiveIds(state, getters, rootState, rootGetters) {
		const settings = rootGetters["globals/getSettings"]
		const filterAEs = settings?.filter_account_executives || []

		// If no filter is set, return empty array (meaning don't filter)
		if (!filterAEs || filterAEs.length === 0) {
			return []
		}

		// Return the list of allowed account executive IDs
		return filterAEs
	},
	getBrokerTargets(state) {
		return state.broker_targets
	},
}
